import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Polls the count of pending payment requests awaiting the caller's approval.
// Only meaningful for admin (customers+resellers) and reseller (own customers).
export function usePendingPaymentsCount(intervalMs = 15000) {
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  const role = user?.role;
  useEffect(() => {
    if (role !== "admin" && role !== "reseller") { setCount(0); return; }
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/billing/payment-requests/pending-count");
        if (alive) setCount(data.count || 0);
      } catch { /* transient — keep last value */ }
    };
    load();
    const t = setInterval(load, intervalMs);
    return () => { alive = false; clearInterval(t); };
  }, [role, intervalMs]);
  return count;
}
